module.exports = __webpack_public_path__ + "img/canada-neoplasm-male.871d1498.png";